import { Locale } from './translations/data'
import { array, option } from 'fp-ts'
import { pipe } from 'fp-ts/lib/function'
import * as effects from 'redux-saga/effects'
import { State as GlobalState } from './store'
import { CancelToken } from 'axios'
import { takeLatest } from './saga'
import {
  GetAccountResultAction,
  PayloadAction,
  payloadActionCreator,
  loadable,
} from '@library/react-toolkit'
import { updateUAAAccount } from './Account/api'

export type State = Locale

export const initialState: State = pipe(
  [...navigator.languages],
  array.findFirst(Locale.is),
  option.getOrElse<Locale>(() => 'en')
)

export type SetLocaleAction = PayloadAction<'set_locale', Locale>
export const setLocaleAction =
  payloadActionCreator<SetLocaleAction>('set_locale')

export type Actions = SetLocaleAction | GetAccountResultAction

export const reducer = (s = initialState, a: Actions): State => {
  switch (a.type) {
    case 'set_locale':
      return a.payload
    case '@react-toolkit/get_account_result':
      return pipe(
        loadable.toOption(a.payload),
        option.chain(p => p.langKey),
        option.filter((l): l is Locale => l === 'en' || l === 'fr'),
        option.getOrElse(() => s)
      )
    default:
      return s
  }
}

function* setLocaleSaga(a: SetLocaleAction, cancelToken?: CancelToken) {
  const lAccount: GlobalState['prosperus']['account'] = yield effects.select(
    (s: GlobalState) => s.prosperus.account
  )

  if (!loadable.isOk(lAccount)) {
    return
  }

  const account = lAccount.value

  yield effects.call(
    updateUAAAccount(
      { ...account, langKey: option.some(a.payload) },
      cancelToken
    )
  )
}

export function* saga() {
  yield effects.all([takeLatest('set_locale', setLocaleSaga)])
}
